// Misura passivamente l'altezza della keyboard nativa del sistema. Quando
// l'utente focusa un input/textarea normale (es. la nota nella tx-modal), la
// visualViewport si rimpicciolisce: salviamo il delta come `--kb-h` per farci
// dimensionare il nostro numpad alla stessa altezza.
//
// Persistito in localStorage per averla pronta anche al primo apertura del
// numpad in sessioni successive.

const STORAGE_KEY = 'gunsi_tally_kb_h'

export function setupKbMeasure() {
  const vv = window.visualViewport
  if (!vv) return

  // Restore measurement saved in past sessions
  const saved = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10)
  if (saved > 150) {
    document.documentElement.style.setProperty('--kb-h', `${saved}px`)
  }

  const onResize = () => {
    const delta = Math.round(window.innerHeight - vv.height)
    // Sanity check: keyboard sits between ~150px and ~70% of viewport
    if (delta > 150 && delta < window.innerHeight * 0.7) {
      document.documentElement.style.setProperty('--kb-h', `${delta}px`)
      try { localStorage.setItem(STORAGE_KEY, String(delta)) } catch {}
    }
  }
  vv.addEventListener('resize', onResize)
}
